import './index.scss'

import Swiper from 'swiper/swiper-bundle.min.js'

var p1_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section3 ul li h2').each(function() { //遍历相同样式名的元素
    var p1 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p1_max = p1 > p1_max ? p1 : p1_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section3 ul li h2').height(p1_max); //给每一个元素设置相同的高度

var product = new Swiper(".section4 .swiper", {
    // navigation: {
    //     nextEl: ".message .swiper-button-next",
    //     prevEl: ".message .swiper-button-prev"
    // },
    loop:true,
    speed:1000,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.923%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.923%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    } 
});

var message = new Swiper(".message .mySwiper", {
    navigation: {
        nextEl: ".message .swiper-button-next",
        prevEl: ".message .swiper-button-prev"
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.923%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.923%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    } 
});
var messageHeight = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.message .swiper .swiper-slide').each(function() { //遍历相同样式名的元素
    var messageHeight1 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    messageHeight = messageHeight1 > messageHeight ? messageHeight1 : messageHeight; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.message .swiper .swiper-slide').height(messageHeight); //给每一个元素设置相同的高度